<template>
  <v-avatar
    :size="size"
    color="primary"
    class="bekki-avatar"
    aria-hidden="true"
    data-cc="bekki-avatar"
  >
    <v-icon icon="$star-sparkle" :size="iconSize" />
  </v-avatar>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  size?: number;
}

const props = withDefaults(defineProps<Props>(), {
  size: 28
});

/** Figma `8713:49600`: the star spans 10.77px of the 28px circle. */
const iconSize = computed((): number => Math.round(props.size * 0.385));
</script>

<style scoped>
.bekki-avatar {
  /**
   * Figma `8713:49600`: same stops as BekkiFab (#3BC6D7 → #1A31D5) but the
   * avatar's gradient runs almost horizontally, teal on the right, blue on
   * the left (userSpace line (30.9,28) → (-4.2,24.1), ≈ 276deg in CSS terms).
   */
  background-image: linear-gradient(
    276deg,
    rgb(var(--v-theme-ai-accent)),
    rgb(var(--v-theme-primary))
  );
}
</style>
